import React, { useState } from 'react'
import memoWithRefs from '@aytm/lib/common/components/memoWithRefs'
import { decodeText } from '@aytm/app/stats/lib/util/helpers'

import useModes from '../states/useModes'

import style from './CompareItemsHeader.module.scss'

export type CompareItemsHeaderProps = {
  title: string
  showExportButton: boolean
  onExportData: (callback: () => void) => void
}

export default memoWithRefs<CompareItemsHeaderProps>(CompareItemsHeader, ['onExportData'], 'CompareItemsHeader')

export function CompareItemsHeader(
  props: CompareItemsHeaderProps & { propsRef?: React.MutableRefObject<Partial<CompareItemsHeaderProps>> }
) {
  const modes = useModes()

  const [exporting, setExporting] = useState(false)

  const onExportClick = () => {
    setExporting(true)
    if (props.propsRef.current.onExportData) {
      props.propsRef.current.onExportData?.(() => {
        setExporting(false)
      })
    } else {
      // eslint-disable-next-line no-console
      console.warn('CompareItems: onExportData callback is not provided')
      setExporting(false)
    }
  }

  return (
    <div className={style.CompareItemsHeader}>
      {modes.fullScreen ? null : (
        <div className={style.CompareItemsHeader__title}>{props.title ? decodeText(props.title) : ''}</div>
      )}
      <div className={style.CompareItemsHeader__controls}>
        {props.showExportButton && !modes.fullScreen ? (
          <div
            className={`${style.CompareItemsHeader__controls__export} ${
              exporting ? style['CompareItemsHeader__controls__export-disabled'] : ''
            }`}
            title="Export data"
            onClick={exporting ? null : onExportClick}
          >
            <i className={exporting ? 'icon-aytmfd-spin afd-spin' : 'icon-aytmfd-export-v2'} />
          </div>
        ) : null}
        {modes.fullScreen ? null : (
          <div
            className={style.CompareItemsHeader__controls__fullscreen}
            title="Expand to full screen"
            onClick={() => void modes.setFullScreen(true)}
          >
            <svg width="100" height="100" viewBox="0 0 100 100">
              <path d="M12.38,22.45V65.88h77V22.45Zm72,38.41H17.42V27.48H84.33ZM32.06,53l-7.44-8.86,7.44-8.87V42H70.39V35.3l7.45,8.87L70.39,53V46.32H32.06Z" />
            </svg>
          </div>
        )}
      </div>
    </div>
  )
}
